var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('h3',[_vm._v("通讯地址："+_vm._s(_vm.model.addr || _vm.model.address))]),_c('h3',[_vm._v("举报电话："+_vm._s(_vm.model.tel))]),_c('h3',[_vm._v("邮箱："+_vm._s(_vm.model.email))])])}
var staticRenderFns = []

export { render, staticRenderFns }